var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mistakesigninaddress-div" }, [
    _c("div", { staticClass: "mistakesigninaddress-top" }, [
      _vm._m(0),
      _c("div", { staticClass: "top-infodiv" }, [
        _c("div", { staticClass: "top-notice" }, [
          _vm._v(_vm._s(_vm.attendInfo.name || "") + "学员，请您前往 "),
          _c("span", { staticClass: "top-notice-address" }, [
            _vm._v(_vm._s(_vm.addressInfo.place || "")),
          ]),
          _vm._v(" 签到！"),
        ]),
        _c("div", { staticClass: "top-currentlocation" }, [
          _vm._v("当前位置：" + _vm._s(_vm.currentPlace || "")),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "mistakesigninaddress-coursetitle" }, [
      _vm._v("您的课程信息如下："),
    ]),
    _c("div", { staticClass: "mistakesigninaddress-normalinfo" }, [
      _c("div", { staticClass: "info-title iconfont icon-rili" }),
      _c("div", { staticClass: "info-text" }, [
        _vm._v(
          _vm._s(
            _vm.dsf.date.format(_vm.addressInfo.beginDateTime, "mm月dd日 hh:ii")
          )
        ),
      ]),
    ]),
    _c("div", { staticClass: "mistakesigninaddress-normalinfo" }, [
      _c("div", { staticClass: "info-title iconfont icon-address" }),
      _c("div", { staticClass: "info-text" }, [
        _vm._v(_vm._s(_vm.addressInfo.place || "")),
      ]),
    ]),
    _c("div", { staticClass: "mistakesigninaddress-normalinfo" }, [
      _c("div", { staticClass: "info-title iconfont icon-xxkc" }),
      _c("div", { staticClass: "info-text" }, [
        _vm._v(_vm._s(_vm.addressInfo.name || "")),
      ]),
    ]),
    _c("div", { staticClass: "mistakesigninaddress-normalinfo" }, [
      _c("div", { staticClass: "info-title iconfont icon-jiaoshi" }),
      _c("div", { staticClass: "info-text" }, [
        _vm._v(_vm._s(_vm.addressInfo.speakerText || "")),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-logo" }, [
      _c("span", { staticClass: "iconfont icon-tixingshixin" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }